module.exports = __webpack_public_path__ + "media/images/angle-down-bg-fc50041736a74ecfa09293d7972dfae5.svg";